export const VERSION = process.env.REACT_APP_VERSION ?? "local";

export const USER_AGENT = `DaDashboard ${VERSION}`;
